import React, { useMemo, useState } from 'react';

import { COLOR_MAP_BG } from '../../theme';
import MarkerMap from '../CommonComponents/GoogleMap/MarkerMap';
import { useDispatch, useSelector } from '../../redux/hooks';
import { fetchTenantsForMap, selectTenantsForMap } from '../../redux/actions/tenants';
import MapSettings from './MapSettings';
import { fetchPublishedPublicOrders, selectPublishedPublicOrders } from '../../redux/actions/orders';
import { BorderColor } from '@mui/icons-material';

export default function Map() {
    const dispatch = useDispatch();
    const [showTenants, setShowTenants] = useState(false);
    const [showOnlyAccepted, setShowOnlyAccepted] = useState(true);
    const [showCarriers, setShowCarriers] = useState(true);
    const [showNonCarriers, setShowNonCarriers] = useState(false);
    const [showJobs, setShowJobs] = useState(true);
    const tenants = useSelector(selectTenantsForMap());
    const publishedPublicOrders = useSelector(selectPublishedPublicOrders());

    React.useEffect(() => {
        dispatch(fetchTenantsForMap());
        dispatch(fetchPublishedPublicOrders());
    }, [dispatch]);

    const filteredTenants = useMemo(() => {
        return showTenants
            ? tenants.filter((t) => (!showOnlyAccepted || t.isAccepted)
                && ((showCarriers && t.isCarrier) || (showNonCarriers && !t.isCarrier)))
            : [];
    }, [tenants, showTenants, showOnlyAccepted, showCarriers, showNonCarriers]);

    const filteredOrders = useMemo(() => {
        return showJobs
            ? publishedPublicOrders.filter((o) => (typeof o.deliveryLat === 'number'
                && typeof o.deliveryLng === 'number'
                && typeof o.pickupLat === 'number'
                && typeof o.pickupLng === 'number'))
            : null;
    }, [publishedPublicOrders, showJobs]);

    return (
        <>
            <div style={{
                position: 'relative'
            }}
            >
                <MapSettings
                    showTenants={showTenants}
                    showCarriers={showCarriers}
                    showNonCarriers={showNonCarriers}
                    setShowCarriers={setShowCarriers}
                    setShowNonCarriers={setShowNonCarriers}
                    setShowTenants={setShowTenants}
                    showOnlyAccepted={showOnlyAccepted}
                    showJobs={showJobs}
                    setShowJobs={setShowJobs}
                    setShowOnlyAccepted={setShowOnlyAccepted}
                    sx={{
                        display: 'block',
                        borderRadius: 1,
                        border: 'none',
                        position: 'absolute',
                        top: 20,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 9,
                        backgroundColor: COLOR_MAP_BG
                    }}
                />
            </div>
            <MarkerMap
                jobs={filteredOrders}
                tenants={filteredTenants}
            />
        </>
    );
}
